import * as _ from 'lodash'
import {IBusinessObject, IBusinessObjectChanges, IBusinessObjectChangesOptions} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider, MessageType} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {WB_PeriodTypeRow} from "../PA.Core/PAdbSchemaRows";
import {IwbPeriodType} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_DataObject, esWB_Entity, esWB_MasterData_Set,
    esWB_Period_Type, esWB_UI_AppExecutable,
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IEntityMetaData} from "../PA.MD.Core/PA.MD.IF.Entity";
import {EntityMetaDataManager} from "../PA.MD.Core/EntityMetaDataManager";
import {PeriodTypeBOValidations} from "./PeriodTypeBO.Validations";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {ASync} from "../PA.Core/Basic/ASync";
import {RecordUtils} from "../PA.Core/Basic/Records";
import {DefaultChanges} from "../PA.Core/BusinessObject/BusinessObjectChanges";


export class PeriodTypeBO implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_PeriodType: WB_PeriodTypeRow;

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New PeriodType'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_PeriodType = null;

        this.IEntity_init()

    }

    get WB_PeriodType(): WB_PeriodTypeRow
    {
        return this.drWB_PeriodType;
    }


    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        var self = this;
        this.LoadProgressProvider.start("Creating PeriodType");
        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, error) => {

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new PeriodType.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_Period_Type)
                .then((newPeriodTypeRow: WB_PeriodTypeRow)=> {
                    newPeriodTypeRow.setDefaults()
                    self.drWB_PeriodType = newPeriodTypeRow;
                    self.dbContext.add(esWB_Period_Type, newPeriodTypeRow)
                    self.updateIdentity();
                    self.IEntity_OnLoadComplete()
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");

                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);

                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err)
                    error(err)
                })

        });

        return this._OnLoadComplete;
    }

    async Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        const self = this;
        let recordResolver: ESRecordResolver;
        let recordResolverLoadPromise: Promise<void>;

        self.LoadProgressProvider.start('Loading (' + self.Identity.id_ui + ')');
        let olc = this._OnLoadComplete = (async () => {
            try {
                if (self.bIsLoaded) {
                    const sError = 'Period Type already loaded.';
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(sError);
                    return self;
                }
                self.LoadOptions = options || {};

                if ('dbContext' in self.LoadOptions) {
                    self.dbContext = self.LoadOptions.dbContext;
                } else if (_.isEmpty(self.dbContext)) {
                    self.dbContext = new PAdbContext();
                }

                if (_.isEmpty(this.dbContext)) {
                    const sError = 'Unable to determine dbContext for Period Type.';
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.exception(sError);
                    return self;
                }

                if ('RecordResolver' in self.LoadOptions) {
                    recordResolver = (<any>self.LoadOptions).RecordResolver;
                    recordResolverLoadPromise = ASync.resolve();
                } else {
                    recordResolver = PeriodTypeBO.createRecordResolver({dbContext: self.dbContext});
                    recordResolverLoadPromise = PeriodTypeBO.setupRecordResolver(recordResolver, [anId]);
                }

                await recordResolverLoadPromise

                const aPeriodTypeRow: any = recordResolver.get(esWB_Period_Type, anId);

                if (_.isEmpty(aPeriodTypeRow)) {
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.exception('Id not found.');
                    return self;
                }

                self.drWB_PeriodType = aPeriodTypeRow;
                self.updateIdentity();
                await self.IEntity_OnLoadComplete()

                self._bIsLoaded = true;
                self._OnLoadComplete = null;
                self.LoadProgressProvider.finish();
                return self
            } catch (err: any) {
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.exception(err);
                return self;
            }
        })();

        return olc;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    async Validate(options?: any): Promise<IBusinessObject> {
        const self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start(
            'Validating ' + self.WB_PeriodType.cif.PERIOD_TYPE_NAME + '(' + self.WB_PeriodType.cif.PERIOD_TYPE_ID + ')'
        )

        self.ValidateOptions = options || {};

        try {
            if (self.dbContext == undefined) {
                const sError = 'Unable to determine dbContext to validate Period Type.';
                self.ValidateProgressProvider.exception(sError);
                throw sError;
            }

            await PeriodTypeBOValidations.ValidateFields(self)
            if(self.EntityMetaData){
                self.EntityMetaData.WB_EntityRow.cif.ENTITY_ID = self.WB_PeriodType.cif.PERIOD_TYPE_ID
                self.EntityMetaData.WB_EntityRow.cif.ENTITY_NAME = self.WB_PeriodType.cif.PERIOD_TYPE_NAME
                self.EntityMetaData.WB_EntityRow.cif.WB_MDSET_ID = self.WB_PeriodType.cif.WB_MDSET_ID

                await self.EntityMetaData.Validate()
                self.ValidateMessageProvider.addMessages(self.EntityMetaData.ValidateMessageProvider.Messages)
            }

            if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                self._bIsValidated = false;
            } else {
                self._bIsValidated = true;
            }
            self.ValidateProgressProvider.finish();

        } catch (err) {
            self._bIsValidated = false;
            self.ValidateProgressProvider.exception(err);

        }
        return self

    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    async SaveUsing(bBatch: boolean,  options?: any): Promise<IBusinessObject> {

        const self = this;
        const wbPeriodType = <IwbPeriodType>self.drWB_PeriodType;
        this.SaveProgressProvider.start(
            'Saving ' + wbPeriodType.PERIOD_TYPE_NAME + '(' + wbPeriodType.PERIOD_TYPE_ID + ')'
        );

        try {
            if (_.isEmpty(self.dbContext)) {
                self._bIsSaved = false;
                const sError = 'Unable to determine dbContext to Save Period Type.';
                self.SaveProgressProvider.exception(sError);
                return self;
            }

            self.SaveOptions = options || {};

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>;

            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext);
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext);
            }

            if(!options?.bSkipValidations) {
                await self.Validate({})

                if (!self.bIsValidated) {
                    self._bIsSaved = false;
                    self.SaveProgressProvider.finish();
                    return self
                }
            }

            await saveFunction(esWB_Period_Type, self.drWB_PeriodType, {})
            if (self.EntityMetaData) {
                await self.EntityMetaData.Save(bBatch)
            }
            if (bBatch) {
                self.dbContext.addBatchCompleteListener(() => {
                    self._bIsSaved = true;
                });
            } else {
                self._bIsSaved = true;
            }

            self.SaveProgressProvider.finish();
        } catch (err) {
            self.SaveProgressProvider.exception(err);

        } finally {

        }
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }


//Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbPeriodType = <IwbPeriodType>self.drWB_PeriodType;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbPeriodType.PERIOD_TYPE_NAME + "(" + wbPeriodType.WB_PERIODM_ID + ")");
        return new Promise<IBusinessObject>( (resolve, error) => {

            // 1. Validate if we can delete the PeriodType

            // 2. If Valid, mark all the records for deletion.
            self.drWB_PeriodType.markDeleted()
            if(self.EntityMetaData)
                self.EntityMetaData.Delete(bSaveNow)
            if(bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }


    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    async Copy(options?: any): Promise<IBusinessObject> {
        const self = this

        const src: PeriodTypeBO = this;

        const tgt = new PeriodTypeBO({});
        await tgt.LoadNew()

        if (!tgt.bIsLoaded)
            throw new Error("Unable to create New Period Type")

        RecordUtils.CopyProperties(tgt.dbContext, esWB_Period_Type,
            src.WB_PeriodType, tgt.WB_PeriodType,
            [],
            ['DELETED_DT', 'DELETED_IND'],
            {})

        tgt.WB_PeriodType.cif.PERIOD_TYPE_ID = "CopyOf" + src.WB_PeriodType.cif.PERIOD_TYPE_ID
        tgt.WB_PeriodType.cif.PERIOD_TYPE_NAME = "Copy of " + src.WB_PeriodType.cif.PERIOD_TYPE_NAME
        tgt.Identity.setAll(tgt.WB_PeriodType.cif.WB_PERIODM_ID, tgt.WB_PeriodType.cif.PERIOD_TYPE_ID, tgt.WB_PeriodType.cif.PERIOD_TYPE_NAME);

        return tgt
    }

    //</editor-fold>
    private updateIdentity(): void {
        const {
            WB_PERIODM_ID,
            PERIOD_TYPE_ID,
            PERIOD_TYPE_NAME
        } = this.WB_PeriodType.cif;
        this.Identity.setAll(WB_PERIODM_ID, PERIOD_TYPE_ID, PERIOD_TYPE_NAME);
        this.LoadProgressProvider.setName(
            'Loading ' + this.Identity.name + '(' + this.Identity.id_ui + ')'
        );
        this.Identity.listenToRecordUpdates(this.WB_PeriodType, 'WB_PERIODM_ID', 'PERIOD_TYPE_ID', 'PERIOD_TYPE_NAME');
        let userContext = PAEnvironment.getValue(PAEnvironment.UserContext, 'UserContext')
        let bHasRole = userContext.hasRoleId("Period_Data_Editor")

        if (bHasRole)
            this.Identity.enableRecordWriteBack(this.WB_PeriodType, 'PERIOD_TYPE_ID', 'PERIOD_TYPE_NAME')
        else
            this.Identity.enableRecordWriteBack(this.WB_PeriodType, undefined, undefined)

    }
    //<editor-fold desc = "Entity">
    _entityMetaData: IEntityMetaData

    IEntity_init(): void {
        // Nothing can be created here
    }

    async IEntity_OnLoadComplete(): Promise<void> {
        let eMgr = new EntityMetaDataManager()
        let metaWbId = this.WB_PeriodType.cif.WB_PERIODM_ID
        let entityId = this.WB_PeriodType.cif.PERIOD_TYPE_ID
        let entityName = this.WB_PeriodType.cif.PERIOD_TYPE_NAME
        let wbMasterDataSetId = this.WB_PeriodType.cif.WB_MDSET_ID

        console.log(wbMasterDataSetId,typeof wbMasterDataSetId)

        let emd = await eMgr.findOrCreate({
            dbContext: this.dbContext,
            appExecId: [entityId, "Period"],
            dataObjectId: "/AZR/WB_PERIOD",
            dataObjectTypeId: "Table",
            setType: "Period",
            metaType: "WB_PeriodM",
            metaWbId: metaWbId,
            wbMasterDataSetId: wbMasterDataSetId,
            entityId: entityId,
            entityName: entityName,
            dimensionId: "Period"
        })

        console.log(emd)
        this._entityMetaData = emd
    }

    get EntityMetaData(): IEntityMetaData { return this._entityMetaData }


    //</editor-fold>

    Changes(options?: IBusinessObjectChangesOptions): IBusinessObjectChanges {
        let opts = options || {}
        opts.dctIncludeBelongsToNamedRelations = opts.dctIncludeBelongsToNamedRelations || {}
        opts.dctExcludeFields = opts.dctExcludeFields || {}

        // Set any BO Specific change settings
        return DefaultChanges(this, this.drWB_PeriodType, opts)
    }

    //<editor-fold desc = "staticIRecordResolver">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {
        const opts = boLoadOptions || {};
        let dbContext: PAdbContext;
        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const period_type_options: CreateOptions = {
            standardConditions: {
            },
            dctIncludeBelongsToNamedRelations: {
                [esWB_Entity]: [esWB_DataObject, esWB_UI_AppExecutable, esWB_MasterData_Set]
            }
        };

        return new ESRecordResolver(dbContext, period_type_options);
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: (string | number)[]): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            recordResolver.findAllWithRelationships(esWB_Period_Type, ids)
                .then(() => {
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }


    //</editor-fold>

};
PAEnvironment.registerBusinessObjectClass(PeriodTypeBO , "PeriodTypeBO", "Period Type")
